// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__ewUTb","footer__content":"Footer_footer__content__icTb4","footer__text":"Footer_footer__text__c5JEA","site_url":"Footer_site_url__eZ9yK"};